import { Tabs, Carousel } from '@materializecss/materialize';

function materializeFunctions() {
  // Initialize Tabs
  const tabs = document.querySelectorAll('.tabs');
  tabs.forEach((tab) => {
    Tabs.init(tab);
  });

  // Initialize Hero Carousel
  const heroCarousels = document.querySelectorAll('.hero-carousel');
  heroCarousels.forEach((carousel) => {
    Carousel.init(carousel, {
      fullWidth: true,
      indicators: true,
      duration: 0
    });
  });

  // Add click event listeners for Hero Carousel navigation
  const prevBtns = document.querySelectorAll('.prev');
  const nextBtns = document.querySelectorAll('.next');

  prevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      heroCarousels.forEach((carousel) => {
        const instance = Carousel.getInstance(carousel);
        instance?.prev();
      });
    });
  });

  nextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      heroCarousels.forEach((carousel) => {
        const instance = Carousel.getInstance(carousel);
        instance?.next();
      });
    });
  });

  // Initialize Ship Carousel
  const shipCarousels = document.querySelectorAll('.ship-carousel');
  const shipCarouselItems = document.querySelectorAll('.carousel-item').length;

  if (shipCarouselItems > 0) {
    shipCarousels.forEach((carousel) => {
      Carousel.init(carousel, {
        fullWidth: true,
        indicators: true,
        duration: 0
      });

      // Get sibling navigation buttons
      const prevBtn = carousel.parentElement.querySelector('.prev');
      const nextBtn = carousel.parentElement.querySelector('.next');
      const instance = Carousel.getInstance(carousel);

      if (prevBtn) {
        prevBtn.addEventListener('click', () => instance?.prev());
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => instance?.next());
      }
    });
  }
}

export default materializeFunctions;
